/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Parties_TitleInputs */

const cs_parties_title = /** @type {(inputs: Parties_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strany`)
};

const en_parties_title = /** @type {(inputs: Parties_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parties`)
};

/**
* | output |
* | --- |
* | "Parties" |
*
* @param {Parties_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const parties_title = /** @type {((inputs?: Parties_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Parties_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_parties_title(inputs)
	return cs_parties_title(inputs)
});